import { DocumentData } from "firebase/firestore";
import { useRecoilValue } from "recoil";
import { singleOrCumsumState } from "../../../store";
import { GridElement } from "../../../types/gridElement";
import { beforeWrapper, showPercentage } from "../../../utils";
import { ShowTableData } from "../../ShowTableData";

export const PlBudgetControlBasisBody = ({
  headers,
  rows,
  title,
  calcState,
  url,
  unit,
}: {
  headers: DocumentData[];
  rows: DocumentData[];
  title: string | null;
  calcState: DocumentData;
  url: string;
  unit: number;
}) => {
  const singleOrCumsumToggle = useRecoilValue(singleOrCumsumState);

  const byItemData = singleOrCumsumToggle
    ? [
        calcState.current_by_item,
        calcState.previous_by_item,
        calcState.current_and_previous_difference_by_item,
        calcState.current_and_previous_difference_by_item_ratio,
        calcState.by_item,
        calcState.current_and_plan_difference_by_item,
        calcState.current_and_plan_difference_by_item_ratio,
      ]
    : [
        calcState.current_by_item_cumsum,
        calcState.previous_by_item_cumsum,
        calcState.current_and_previous_difference_by_item_cumsum,
        calcState.current_and_previous_difference_by_item_ratio_cumsum,
        calcState.plan_by_item_cumsum,
        calcState.current_and_plan_difference_by_item_cumsum,
        calcState.current_and_plan_difference_by_item_ratio_cumsum,
      ];

  const byItemTotalData = [
    calcState.current_by_item_total,
    calcState.previous_by_item_total,
    calcState.current_and_previous_difference_by_item_total,
    calcState.current_and_previous_difference_by_item_total_ratio,
    calcState.plans_input,
    calcState.current_and_plan_difference_by_item_total,
    calcState.current_and_plan_difference_by_item_total_ratio,
  ];

  const grid: GridElement[][] = [];
  {
    rows.map((row: DocumentData, rowIndex: number) => {
      // className
      const classCol1 = `${beforeWrapper} left-0 w-80px min-w-[5rem] pl-4px  top-0 font-bold align-text-top mt-12px bg-white before:border-l z-[32]`;

      const classCol2 = `${beforeWrapper} w-140px max-w-[8.75rem] left-80px p-4px bg-white before:border-b before:border-l before:border-l-c3333334d ${
        rows.length !== rowIndex + 1 && "before:border-b-c3333334d"
      } ${rowIndex % 2 !== 0 && "before:bg-c2a4b770d"}`;

      const classCol3 = `${beforeWrapper} left-220px p-4px bg-white before:border-b before:border-x before:border-x-c3333334d ${
        rows.length !== rowIndex + 1 && "before:border-b-c3333334d"
      }  ${rowIndex % 2 !== 0 && "before:bg-c2a4b770d"}`;

      const classCol4 = `relative p-4px before:border-b before:border-l before:absolute before:w-full before:h-full  before:top-0 before:left-0 before:-z-10 ${
        rows.length !== rowIndex + 1 && " before:border-b-c3333334d"
      } text-right   ${rowIndex % 2 !== 0 && "bg-c2a4b770d"}`;

      const classCol5 = `relative p-4px before:border-b before:border-l before:absolute before:w-full before:h-full  before:top-0 before:left-0 before:-z-10 before:border-r ${
        rows.length !== rowIndex + 1 && "before:border-b-c3333334d"
      }  ${rowIndex % 2 !== 0 && "bg-c2a4b770d"} text-left  h-50px description`;

      // 行の値
      const gridRow = [];

      gridRow.push({
        value: rowIndex === 0 ? title : "",
        expr: rowIndex === 0 ? title : "",
        readOnly: true,
        className: classCol1,
        row: row,
        url: url,
        key: "",
      });

      gridRow.push(
        { value: row.item, readOnly: true, className: classCol2 },
        {
          value: row.section,
          readOnly: true,
          className: `${classCol3} border-x-c3333334d`,
        }
      );

      headers.map((_, headerIndex: number) => {
        byItemData.map((data: number[][], dataIndex: number) => {
          gridRow.push({
            value:
              data !== null &&
              isNaN(data[rowIndex][headerIndex]) &&
              (dataIndex === 3 || dataIndex === 6)
                ? "0%"
                : data !== null && isNaN(data[rowIndex][headerIndex])
                ? 0
                : data !== null && (dataIndex === 3 || dataIndex === 6)
                ? `${showPercentage(data[rowIndex][headerIndex])}%`
                : data !== null
                ? ShowTableData(data[rowIndex][headerIndex] / unit)
                : 0,
            expr:
              data !== null &&
              isNaN(data[rowIndex][headerIndex]) &&
              (dataIndex === 3 || dataIndex === 6)
                ? "0%"
                : data !== null && isNaN(data[rowIndex][headerIndex])
                ? 0
                : data !== null && (dataIndex === 3 || dataIndex === 6)
                ? `${showPercentage(data[rowIndex][headerIndex])}%`
                : data !== null
                ? data[rowIndex][headerIndex] / unit
                : 0,
            readOnly: true,
            className: `${classCol4} ${
              dataIndex === 0
                ? "before:bg-cfffee2"
                : "before:border-l-c3333334d"
            }`,
            colSpan: 1,
          });
        });
      });

      // 合計
      singleOrCumsumToggle &&
        byItemTotalData.map((data: number[], dataIndex: number) => {
          gridRow.push({
            value:
              data !== null && (dataIndex === 3 || dataIndex === 6)
                ? `${showPercentage(data[rowIndex])}%`
                : data !== null
                ? ShowTableData(data[rowIndex] / unit)
                : "",
            expr:
              data !== null && (dataIndex === 3 || dataIndex === 6)
                ? `${showPercentage(data[rowIndex])}%`
                : data !== null
                ? data[rowIndex] / unit
                : "",
            readOnly: true,
            className: `${classCol4} ${
              dataIndex === 0
                ? "before:bg-cfffee2"
                : "before:border-l-c3333334d"
            }`,
            colSpan: 1,
          });
        });

      gridRow.push({
        value: row?.descriptions[`${url}_${row?.field as string}`],
        expr: row?.descriptions[`${url}_${row?.field as string}`],
        readOnly: false,
        className: classCol5,
        row: row,
        url: url,
        key: "descriptions",
        colSpan: 1,
      });
      grid.push(gridRow);
    });
  }

  return grid;
};
